import { all, call, put, takeLatest } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';
import authApi from '../../@template/services/auth/authApi/authenticatedApi';
import { apiConfig } from '../../config';
import { WatchlistStudent } from '../../types/models/WatchlistStudentModel';
import { ICommonSavePayload } from '../Common.actions';
import {
  WATCHLIST,
  watchlistLoadSuccess,
  watchlistLoadError,
  watchlistSaveSuccess,
  watchlistSaveError,
  watchlistDeleteSuccess,
  watchlistLoadByCompany,
} from './Actions';

// Worker Saga: Receives the Redux action object
function* WatchlistLoadByCompany(action: PayloadAction<string>) {
  const companyId = action.payload;
  console.log('SAGA - watchlistSaga - WatchlistLoadByCompany:', companyId);
  try {
    const res = yield call([authApi, authApi.request], {
      baseURL: apiConfig.coreUrl,
      method: 'GET',
      url: `${apiConfig.coreCompaniesPath}/${companyId}/watchlist`,
    });

    const rawData = Array.isArray(res.data) ? res.data : (res.data?.items || []);
    const result: WatchlistStudent[] = rawData.map((x: any) => WatchlistStudent.fromJS(x));

    yield put(watchlistLoadSuccess(result));
  } catch (err: any) {
    yield put(watchlistLoadError(err?.message || err));
  }
}

// Worker Saga: Receives save payload action
function* WatchlistSave(action: PayloadAction<ICommonSavePayload<any>>) {
  const { submission } = action.payload;
  console.log('SAGA - watchlistSaga - WatchlistSave:', submission);
  try {
    const res = yield call([authApi, authApi.request], {
      baseURL: apiConfig.coreUrl,
      method: 'POST',
      url: `${apiConfig.coreCompaniesPath}/${submission.companyId}/watchlist`,
      data: submission,
    });

    const item: WatchlistStudent = WatchlistStudent.fromJS(res.data);
    yield put(watchlistSaveSuccess(item));

  } catch (err: any) {
    yield put(watchlistSaveError(err?.message || err));
  }
}

// Worker Saga: Receives delete id action
function* WatchlistDelete(action: PayloadAction<string>) {
  const watchlistId = action.payload;
  console.log('SAGA - watchlistSaga - WatchlistDelete:', watchlistId);
  try {
    yield call([authApi, authApi.request], {
      baseURL: apiConfig.coreUrl,
      method: 'DELETE',
      url: `${apiConfig.coreCompaniesPath}/watchlist/${watchlistId}`,
    });
    yield put(watchlistDeleteSuccess(watchlistId));
  } catch (err: any) {
    yield put(watchlistLoadError(err?.message || err));
  }
}

// Watcher Sagas: Pass the generator functions directly
export function* watchWatchlistLoadByCompany() {
  yield takeLatest(WATCHLIST.LOAD_BY_COMPANY, WatchlistLoadByCompany);
}

export function* watchWatchlistSave() {
  yield takeLatest(WATCHLIST.SAVE, WatchlistSave);
}

export function* watchWatchlistDelete() {
  yield takeLatest(WATCHLIST.DELETE, WatchlistDelete);
}

function* WatchlistLoadByStudent(action: PayloadAction<string[]>) {
  try {
    const res = yield call([authApi, authApi.request], {
      baseURL: apiConfig.coreUrl,
      method: 'POST',
      url: `${apiConfig.coreStudentPath}/watchlist/list`,
      data: {
        id_list: action.payload
      }
    });
    const result = (res.data || []).map((x: any) => WatchlistStudent.fromJS(x));
    yield put(watchlistLoadSuccess(result));
  } catch (err: any) {
    yield put(watchlistLoadError(err?.message || err));
  }
}

export function* watchWatchlistLoadByStudent() {
  yield takeLatest(WATCHLIST.LOAD_BY_STUDENT, WatchlistLoadByStudent);
}

export default function* watchlistSaga() {
  yield all([
    call(watchWatchlistLoadByCompany),
    call(watchWatchlistSave),
    call(watchWatchlistDelete),
    call(watchWatchlistLoadByStudent),
  ]);
}